import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: "",
  success: "",
  user: {}
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    profileSuccess(state :any, action :any) {
      state.success = action.payload;
      state.user = action.payload.data;
    },
    profileError(state :any, action :any) {
      state.error = action.payload;
    },
    editProfileChange(state :any) {
      state = { ...state };
    },
    resetProfileFlagChange(state :any) {
      state.success = "";
      state.error = "";
    }
  },
});

export const {
  profileSuccess,
  profileError,
  editProfileChange,
  resetProfileFlagChange
} = ProfileSlice.actions;

export default ProfileSlice.reducer;